import { Pipe, PipeTransform, inject } from '@angular/core';
import {Prestatie} from './prestatie';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'zahPrestatieDatum',
    standalone: false
})
export class PrestatieDatumPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(prestatie: Prestatie): string {
    return `${this.datePipe.transform(prestatie.getStartTijdstip(), 'd MMMM yyyy')}`;
  }
}
